import { render } from "./OrderManage.vue?vue&type=template&id=f58d230c&scoped=true"
import script from "./OrderManage.vue?vue&type=script&lang=js"
export * from "./OrderManage.vue?vue&type=script&lang=js"

import "./OrderManage.vue?vue&type=style&index=0&id=f58d230c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f58d230c"]])

export default __exports__